import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { ColumnMode, SelectionType } from '@swimlane/ngx-datatable';
import {
  GroupsUsers,
  RoleUser,
  Users,
} from '../../interfaces/groups-user.interface';
// import { groupsUsersMock } from "./groups-users.mock";
import { COMMA, ENTER, SPACE, FF_SEMICOLON } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { MatDialog } from '@angular/material/dialog';
import { ModalGroupsUsersComponent } from '../../components/modal-groups-users/modal-groups-users.component';
import { TranslateService } from '../../services/translate/translate.service';
import { Subscription } from 'rxjs';
import { ModalDeleteComponent } from '../../components/modal-delete/modal-delete.component';
import { GroupsUsersService } from '../../services/groups/groups-users.service';
import { ToastrService } from 'ngx-toastr';
import {
  EmailsGroups,
  ModalAddUsersGroupsComponent,
} from '../../components/modal-add-users-groups/modal-add-users-groups.component';

@Component({
  selector: 'mg-groups-users',
  templateUrl: './groups-users-mg.component.html',
  styleUrls: ['./groups-users-mg.component.scss'],
})
export class GroupsUsersMgComponent implements OnInit, OnChanges, OnDestroy {
  @Input() group!: { pk: string; sk: string };
  modeColum = ColumnMode.force;
  selectionType = SelectionType;
  subscriptionTranslate!: Subscription;
  groupsUsers: GroupsUsers[] = [];
  search = '';
  loading: boolean = true;
  showSearch: boolean = false;
  groupUserSelected: GroupsUsers = {} as GroupsUsers;
  dataTranslateUserGroups!: any;
  loadingTable = false;
  readonly separatorKeysCodes = [ENTER, COMMA, FF_SEMICOLON, SPACE] as const;
  addOnBlur = true;
  columns = [
    { name: 'email', label: 'Email' },
    { name: 'status', label: 'Status' },
  ];
  rows = [];
  selected: Users[] = [];
  constructor(
    public dialog: MatDialog,
    private translate: TranslateService,
    private groupsUsersService: GroupsUsersService,
    private toast: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadGroupsUsers();
    this.getTranslate();
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (this.group?.sk) {
      this.loadGroupsUsers();
    }
  }

  loadGroupsUsers(group: GroupsUsers = {} as GroupsUsers) {
    this.loading = true;
    this.groupsUsersService
      .getGroupsUsers(this.group.pk, this.group.sk)
      .subscribe({
        next: ({ data }) => {
          this.groupsUsers = data.map((groupInfo) => {
            return {
              ...groupInfo,
              users: groupInfo.users.filter((user) => user.email),
            };
          });
          if (group?.group) {
            this.groupUserSelected = this.groupsUsers.find(
              (itemGroup) => itemGroup.group.sk === group.group.sk
            ) as GroupsUsers;
            if (!this.groupUserSelected?.group) {
              this.groupUserSelected =
                data.length > 0 ? data[0] : ({} as GroupsUsers);
            }
            this.loading = false;
            return;
          }
          if (this.groupsUsers.length > 0) {
            this.groupUserSelected = this.groupsUsers[0];
          }
          this.loading = false;
        },
        error: (error) => {
          this.toast.error(error.error.errorMessage, 'Error');
          console.error(error.error.errorMessage);
        },
      });
  }

  getClass(row: any) {
    return {
      isPending: row.value == 'pending',
      isActived: row.value == 'active',
    };
  }

  selectedGroup(item: GroupsUsers) {
    this.groupUserSelected = item;
    this.selected = [];
  }

  resend(user: Users) {
    if (user.status !== 'active') {
      this.loadingTable = true;
      this.groupsUsersService
        .reSendInvitation(
          user.email,
          user.roles[0].properties.name,
          this.groupUserSelected.group.pk,
          this.groupUserSelected.group.sk
        )
        .subscribe({
          next: () => {
            this.loadingTable = false;
            this.toast.success(
              this.dataTranslateUserGroups.toasts.contentReSendInvite,
              this.dataTranslateUserGroups.toasts.titleReSendInvite
            );
          },
          error: (error) => {
            this.loadingTable = false;
            this.toast.error(error.error.errorMessage, 'Error');
            console.error(error.error.errorMessage);
          },
        });
    }
  }

  selectionChange(user: Users, { value }: { value: string }) {
    this.loadingTable = true;
    this.groupsUsersService
      .updateUserRole(user, value, this.groupUserSelected)
      .subscribe({
        next: () => {
          let newUsers = this.groupUserSelected.users;
          newUsers = newUsers.map((userItem) =>
            userItem.username === user.username
              ? {
                  ...userItem,
                  roles: [{ properties: { name: value } }] as RoleUser[],
                }
              : userItem
          );
          this.groupUserSelected.users = [...newUsers];
          this.groupsUsers = this.groupsUsers.map((group) =>
            group.group.pk === this.groupUserSelected.group.pk &&
            group.group.sk === this.groupUserSelected.group.sk
              ? this.groupUserSelected
              : group
          );
          this.loadingTable = false;
          this.toast.success(
            this.dataTranslateUserGroups.toasts.changeStatusContent,
            this.dataTranslateUserGroups.toasts.changeStatusTitle
          );
        },
        error: (error) => {
          this.loadingTable = false;
          this.toast.error(error.error.errorMessage, 'Error');
          console.error(error.error.errorMessage);
        },
      });
  }

  removeUser(user: Users) {
    if (user.status === 'active') {
      this.deleteUsers([user.username], []);
    } else {
      this.deleteUsers([], [user.email.toLowerCase()]);
    }
  }

  allDelete() {
    const elementtActive = this.selected.filter(
      (user) => user.status === 'active'
    );
    const elementtPending = this.selected.filter(
      (user) => user.status !== 'active'
    );

    this.deleteUsers(
      elementtActive.map((item) => item.username),
      elementtPending.map((item) => item.email.toLowerCase())
    );
  }

  onSelect({ selected }: { selected: Users[] }) {
    this.selected.splice(0, this.selected.length);
    selected.forEach((element: any) => {
      this.selected.push(element);
    });
  }

  addGroup() {
    const dialogRef = this.dialog.open(ModalGroupsUsersComponent, {
      height: '350px',
      width: '500px',
      disableClose: true,
    });
    dialogRef
      .afterClosed()
      .subscribe(
        ({
          resp,
          name,
          file,
        }: {
          resp: boolean;
          name: string;
          file: string;
        }) => {
          if (resp) {
            this.loading = true;
            this.groupsUsersService
              .addGroup(name, this.group.sk, file)
              .subscribe({
                next: () => {
                  setTimeout(() => {
                    this.loadGroupsUsers();
                    this.toast.success(
                      this.dataTranslateUserGroups.toasts.contentNew,
                      this.dataTranslateUserGroups.toasts.titleNew
                    );
                  }, 1000);
                },
                error: (error) => {
                  this.loading = false;
                  this.toast.error(error.error.errorMessage, 'Error');
                  console.error(error.error.errorMessage);
                },
              });
          }
        }
      );
  }
  deleteUsers(users: string[] = [], emails: string[] = []) {
    if (users.length > 0 || emails.length > 0) {
      const dialogRef = this.dialog.open(ModalDeleteComponent, {
        height: '250px',
        width: '400px',
        disableClose: true,
      });
      dialogRef.afterClosed().subscribe(({ resp }: { resp: boolean }) => {
        if (resp) {
          this.loadingTable = true;
          this.groupsUsersService
            .deleteUsers(users, emails, {
              pk: this.groupUserSelected.group.pk,
              sk: this.groupUserSelected.group.sk,
            })
            .subscribe({
              next: ({ data, invitationsDeleted }) => {
                const users = [...this.groupUserSelected.users];
                const elements = data;
                invitationsDeleted.forEach((item) => {
                  elements.push({ data: item });
                });
                elements.forEach(({ data }) => {
                  const userIndex = users.findIndex(
                    (index) => index.sk === data.sk && index.pk === data.pk
                  );
                  users.splice(userIndex, 1);
                });
                this.groupUserSelected = {
                  ...this.groupUserSelected,
                  users,
                };
                this.groupsUsers = this.groupsUsers.map((group) =>
                  group.group.sk === this.groupUserSelected.group.sk &&
                  group.group.pk === this.groupUserSelected.group.pk
                    ? this.groupUserSelected
                    : group
                );
                this.groupsUsers = [...this.groupsUsers];
                this.selected = [];
                this.loadingTable = false;
                if (data.length > 0) {
                  this.toast.success(
                    this.dataTranslateUserGroups.toasts
                      .toastBulkDeleteUserDescription,
                    this.dataTranslateUserGroups.toasts.toastBulkDeleteUserTitle
                  );
                } else {
                  this.toast.success(
                    this.dataTranslateUserGroups.toasts
                      .toastDeleteUserDescription,
                    this.dataTranslateUserGroups.toasts.toastDeleteUserTitle
                  );
                }
              },
              error: (error) => {
                this.loadingTable = false;
                this.toast.error(error.error.errorMessage, 'Error');
                console.error(error.error.errorMessage);
              },
            });
        }
      });
    }
  }

  sendInvitation() {
    this.loadingTable = true;
  }

  addUser() {
    const dialogRef = this.dialog.open(ModalAddUsersGroupsComponent, {
      minHeight: '350px',
      width: '700px',
      disableClose: false,
      data: this.getRoles(),
    });
    dialogRef
      .afterClosed()
      .subscribe((data: { resp: boolean; users: EmailsGroups[] }) => {
        if (data?.resp) {
          this.loadingTable = true;
          this.groupsUsersService
            .sendInvitation(data.users, [
              {
                pk: this.groupUserSelected.group.pk,
                sk: this.groupUserSelected.group.sk,
                color: this.groupUserSelected.group.roles[0].properties.color,
                skStatus: this.groupUserSelected.group.roles[0].properties.sk,
              },
            ])
            .subscribe({
              next: ({ data }) => {
                data.forEach((userItem: any) => {
                  const group = this.groupUserSelected.group;
                  const groupSelected = this.groupsUsers.find(
                    (groupItem) =>
                      groupItem.group.pk === group.pk &&
                      groupItem.group.sk === group.sk
                  ) as GroupsUsers;
                  if (groupSelected) {
                    const users = [...groupSelected.users];
                    if (
                      !users.some(
                        (user) =>
                          user.pk === userItem.pk && user.sk === userItem.sk
                      )
                    ) {
                      users.push({
                        ...userItem,
                        roles: [
                          {
                            properties: {
                              name: userItem.statusGroup,
                            },
                          },
                        ],
                      });
                      const newGroupSelected = {
                        ...groupSelected,
                        users,
                      };
                      this.groupsUsers = this.groupsUsers.map((groupItem) =>
                        groupItem.group.pk === newGroupSelected.group.pk &&
                        groupItem.group.sk === newGroupSelected.group.sk
                          ? newGroupSelected
                          : groupItem
                      );
                    }
                  }
                });
                this.groupUserSelected = this.groupsUsers.find(
                  (groupItem) =>
                    groupItem.group.pk === this.groupUserSelected.group.pk &&
                    groupItem.group.sk === this.groupUserSelected.group.sk
                ) as GroupsUsers;
                this.loadingTable = false;
              },
              error: (error) => {
                this.loadingTable = false;
                this.toast.error(error.error.errorMessage, 'Error');
                console.error(error.error.errorMessage);
              },
            });
        }
      });
  }
  getRoles(): string[] {
    return this.groupUserSelected.group.roles.map(
      (role) => role.properties.name
    );
  }

  getTranslate() {
    this.subscriptionTranslate = this.translate
      .init('core')
      .subscribe((data) => {
        this.dataTranslateUserGroups = data.userGroups;
      });
  }

  ngOnDestroy(): void {
    this.subscriptionTranslate?.unsubscribe();
  }
}
